// Mock data for VPS hosting website

export const mainPlans = [
  {
    id: 1,
    name: "Starter",
    popular: false,
    ram: "1GB",
    cpu: "1 Core",
    storage: "10GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 2.98,
    features: [
      "Full Root Access",
      "99.9% Uptime SLA",
      "24/7 Support",
      "DDoS Protection",
      "Multiple OS Options"
    ]
  },
  {
    id: 2,
    name: "Developer",
    popular: false,
    ram: "2GB",
    cpu: "2 Cores",
    storage: "15GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 7.99,
    features: [
      "Full Root Access",
      "99.9% Uptime SLA",
      "24/7 Support",
      "DDoS Protection",
      "Multiple OS Options",
      "Weekly Backups"
    ]
  },
  {
    id: 3,
    name: "Pro",
    popular: true,
    ram: "4GB",
    cpu: "2 Cores",
    storage: "25GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 17.99,
    features: [
      "Full Root Access",
      "99.95% Uptime SLA",
      "24/7 Priority Support",
      "Advanced DDoS Protection",
      "Multiple OS Options",
      "Daily Backups",
      "Control Panel"
    ]
  },
  {
    id: 4,
    name: "Business",
    popular: false,
    ram: "8GB",
    cpu: "4 Cores",
    storage: "50GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 38.99,
    features: [
      "Full Root Access",
      "99.95% Uptime SLA",
      "24/7 Priority Support",
      "Advanced DDoS Protection",
      "Multiple OS Options",
      "Daily Backups",
      "Control Panel",
      "Monitoring Tools"
    ]
  }
];

export const additionalPlans = [
  {
    id: 5,
    name: "Enterprise",
    ram: "16GB",
    cpu: "8 Cores",
    storage: "100GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 69.99,
    features: [
      "Full Root Access",
      "99.98% Uptime SLA",
      "24/7 Premium Support",
      "Enterprise DDoS Protection",
      "Multiple OS Options",
      "Real-time Backups",
      "Advanced Control Panel",
      "Monitoring & Analytics",
      "Load Balancer Ready"
    ]
  },
  {
    id: 6,
    name: "Rocket",
    ram: "32GB",
    cpu: "16 Cores",
    storage: "200GB",
    port: "1Gbps",
    transfer: "Unlimited",
    price: 159.99,
    features: [
      "Full Root Access",
      "99.98% Uptime SLA",
      "24/7 Dedicated Support",
      "Enterprise DDoS Protection",
      "Multiple OS Options",
      "Real-time Backups",
      "Advanced Control Panel",
      "Monitoring & Analytics",
      "Load Balancer Ready",
      "Dedicated IP Pool"
    ]
  }
];

export const locations = [
  {
    id: 1,
    country: "Netherlands",
    city: "Meppel",
    flag: "/flags/nl.svg",
    latency: "Perfect for Western Europe",
    features: ["High Security", "GDPR Compliant"]
  },
  {
    id: 2,
    country: "Germany",
    city: "Dusseldorf",
    flag: "/flags/de.svg",
    latency: "Optimal for Central Europe",
    features: ["GDPR Compliant", "Low Latency"]
  },
  {
    id: 3,
    country: "Poland",
    city: "Gdansk",
    flag: "/flags/pl.svg",
    latency: "Best for Eastern Europe",
    features: ["High Security", "EU Regulations"]
  },
  {
    id: 4,
    country: "Latvia",
    city: "Riga",
    flag: "/flags/lv.svg",
    latency: "Great for Baltic Region",
    features: ["High Security", "EU Regulations"]
  },
  {
    id: 5,
    country: "Czech Republic",
    city: "Prague",
    flag: "/flags/cz.svg",
    latency: "Central European Hub",
    features: ["NIX.CZ Peering", "GDPR Compliant"]
  },
  {
    id: 7,
    country: "Switzerland",
    city: "Geneva",
    flag: "/flags/ch.svg",
    latency: "Premium European Hub",
    features: ["Swiss Quality", "Banking-Grade Security"]
  },
  {
    id: 8,
    country: "USA",
    city: "Miami",
    flag: "/flags/us.svg",
    latency: "Gateway to the Americas",
    features: ["1Gbps Port", "DDoS Protection"]
  },
  {
    id: 9,
    country: "Bulgaria",
    city: "Sofia",
    flag: "/flags/bg.svg",
    latency: "Balkan crossroads — East meets West",
    features: ["BIX.BG peering", "EU GDPR"]
  },
  {
    id: 10,
    country: "Greece",
    city: "Thessaloniki",
    flag: "/flags/gr.svg",
    latency: "Mediterranean data port",
    features: ["GR-IX peering", "Submarine cable landing"]
  },
  {
    id: 11,
    country: "Spain",
    city: "Barcelona",
    flag: "/flags/es.svg",
    latency: "Where the Mediterranean meets the network",
    features: ["CATNIX peering", "Submarine cable landing"]
  },
  {
    id: 12,
    country: "Romania",
    city: "Bucharest",
    flag: "/flags/ro.svg",
    latency: "Southeast Europe hub",
    features: ["EU GDPR Compliant", "Low latency to Balkans"]
  },
  {
    id: 12,
    country: "Ukraine",
    city: "Kyiv",
    flag: "/flags/ua.svg",
    latency: "Eastern Europe",
    features: ["Local routing", "Low latency across Ukraine"]
  }
];

export const navigationItems = [
  { name: "Home", href: "/" },
  { name: "Pricing", href: "#pricing" },
  { name: "Locations", href: "#locations" },
  { name: "Support", href: "/support" },
  { name: "About", href: "/about" }
];

export const features = [
  {
    title: "Lightning Fast NVMe",
    description: "Enterprise-grade NVMe SSD storage ensures maximum performance for your applications.",
    icon: "Zap"
  },
  {
    title: "99.9% Uptime SLA",
    description: "Guaranteed uptime with redundant infrastructure and 24/7 monitoring.",
    icon: "Shield"
  },
  {
    title: "24/7 Expert Support",
    description: "Our technical experts are available around the clock to assist you.",
    icon: "HeadphonesIcon"
  },
  {
    title: "Full Root Access",
    description: "Complete control over your VPS with root access and custom configurations.",
    icon: "Settings"
  },
  {
    title: "Dedicated IP Address",
    description: "Get your own dedicated IPv4 and IPv6 addresses for maximum flexibility.",
    icon: "Network"
  },
  {
    title: "Multiple OS Options",
    description: "Choose from various Linux distributions and Windows Server editions.",
    icon: "Monitor"
  }
];

export const stats = [
  {
    id: 1,
    number: 15000,
    suffix: "+",
    label: "Happy Clients",
    description: "Developers & businesses trust us"
  },
  {
    id: 2,
    number: 99.98,
    suffix: "%",
    label: "Uptime",
    description: "Guaranteed infrastructure reliability"
  },
  {
    id: 3,
    number: 24,
    suffix: "/7",
    label: "Support",
    description: "Round-the-clock technical assistance"
  },
  {
    id: 4,
    number: 0,
    suffix: "∞",
    label: "Безлимитный трафик",
    description: "Неограниченная пропускная способность"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alex Rodriguez",
    role: "DevOps Engineer",
    company: "TechStart Inc.",
    avatar: "👨‍💻",
    rating: 5,
    text: "NetGrid has been incredibly reliable. The Amsterdam location gives us perfect latency for our European customers, and their support team is always helpful."
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "CTO",
    company: "DataFlow Systems",
    avatar: "👩‍💼",
    rating: 5,
    text: "We migrated from AWS and couldn't be happier. Better performance, lower costs, and actual human support when we need it. Highly recommended!"
  },
  {
    id: 3,
    name: "Marcus Weber",
    role: "Full Stack Developer",
    company: "FreelanceCode",
    avatar: "👨‍🎨",
    rating: 5,
    text: "The deployment process is lightning fast, and the NVMe storage makes a huge difference for my applications. Worth every penny!"
  }
];

export const faqData = [
  {
    id: 1,
    question: "How quickly can I deploy my VPS?",
    answer: "Your VPS will be ready within 60 seconds after payment. Our automated provisioning system ensures instant deployment across all locations."
  },
  {
    id: 2,
    question: "Do you provide free migration assistance?",
    answer: "Yes! We offer completely free migration assistance from any hosting provider. Our technical team will handle the entire process to ensure zero downtime."
  },
  {
    id: 3,
    question: "What operating systems are available?",
    answer: "We support Ubuntu (20.04, 22.04, 24.04), CentOS (7, 8, Stream 9), Debian (10, 11, 12), AlmaLinux (8, 9), Rocky Linux (8, 9), and Windows Server (2016, 2019, 2022). Custom OS installations are also available upon request."
  },
  {
    id: 4,
    question: "Is there a money-back guarantee?",
    answer: "Absolutely! We offer a 3-day money-back guarantee. If you're not completely satisfied with our service, we'll refund your money, no questions asked."
  },
  {
    id: 5,
    question: "How is billing handled?",
    answer: "We offer flexible billing cycles - monthly, quarterly, and annual. All payments are processed securely, and you can cancel anytime without penalties."
  }
];

export const competitorComparison = [
  {
    feature: "Deployment Time",
    us: "< 60 seconds",
    competitor: "5-15 minutes"
  },
  {
    feature: "Support Response",
    us: "< 5 minutes",
    competitor: "24-48 hours"
  },
  {
    feature: "Storage Type",
    us: "NVMe SSD",
    competitor: "Standard SSD"
  },
  {
    feature: "Backup Frequency",
    us: "Daily/Real-time",
    competitor: "Weekly"
  },
  {
    feature: "DDoS Protection",
    us: "Included",
    competitor: "Extra cost"
  }
];

// Russian translations for locations
export const locationsRu = [
  {
    id: 1,
    country: "Нидерланды",
    city: "Меппел",
    flag: "/flags/nl.svg",
    latency: "Идеально для Западной Европы",
    features: ["Высокая безопасность", "Соответствие GDPR"]
  },
  {
    id: 2,
    country: "Германия",
    city: "Дюссельдорф",
    flag: "/flags/de.svg",
    latency: "Оптимально для Центральной Европы",
    features: ["Соответствие GDPR", "Низкая задержка"]
  },
  {
    id: 3,
    country: "Польша",
    city: "Гданьск",
    flag: "/flags/pl.svg",
    latency: "Лучше всего для Восточной Европы",
    features: ["Высокая безопасность", "Нормы ЕС"]
  },
  {
    id: 4,
    country: "Латвия",
    city: "Рига",
    flag: "/flags/lv.svg",
    latency: "Отлично для Прибалтики",
    features: ["Высокая безопасность", "Нормы ЕС"]
  },
  {
    id: 5,
    country: "Чехия",
    city: "Прага",
    flag: "/flags/cz.svg",
    latency: "Центральноевропейский хаб",
    features: ["Пиринг NIX.CZ", "GDPR соответствие"]
  },
  {
    id: 7,
    country: "Швейцария",
    city: "Женева",
    flag: "/flags/ch.svg",
    latency: "Премиум европейский хаб",
    features: ["Швейцарское качество", "Безопасность банковского уровня"]
  },
  {
    id: 8,
    country: "США",
    city: "Майами",
    flag: "/flags/us.svg",
    latency: "Шлюз в Америку",
    features: ["Порт 1Gbps", "DDoS защита"]
  },
  {
    id: 9,
    country: "Болгария",
    city: "София",
    flag: "/flags/bg.svg",
    latency: "Балканский перекрёсток — Восток встречает Запад",
    features: ["Пиринг BIX.BG", "GDPR ЕС"]
  },
  {
    id: 10,
    country: "Греция",
    city: "Салоники",
    flag: "/flags/gr.svg",
    latency: "Средиземноморский порт данных",
    features: ["Пиринг GR-IX", "Посадка подводных кабелей"]
  },
  {
    id: 11,
    country: "Испания",
    city: "Барселона",
    flag: "/flags/es.svg",
    latency: "Там, где Средиземноморье встречает сеть",
    features: ["Пиринг CATNIX", "Посадка подводных кабелей"]
  },
  {
    id: 12,
    country: "Румыния",
    city: "Бухарест",
    flag: "/flags/ro.svg",
    latency: "Хаб Юго-Восточной Европы",
    features: ["Соответствие GDPR", "Низкая задержка к Балканам"]
  },
  {
    id: 12,
    country: "Украина",
    city: "Киев",
    flag: "/flags/ua.svg",
    latency: "Восточная Европа",
    features: ["Локальная маршрутизация", "Низкая задержка по Украине"]
  }
];

// Russian translations for FAQ
export const faqDataRu = [
  {
    id: 1,
    question: "Как быстро я могу развернуть свой VPS?",
    answer: "Ваш VPS будет готов в течение 60 секунд после оплаты заказа. Наша автоматизированная система обеспечивает мгновенное развертывание во всех локациях."
  },
  {
    id: 2,
    question: "Предоставляете ли вы бесплатную помощь в миграции?",
    answer: "Да! Мы предлагаем абсолютно бесплатную помощь в миграции от любого хостинг-провайдера. Наша техническая команда обработает весь процесс, чтобы обеспечить нулевое время простоя."
  },
  {
    id: 3,
    question: "Какие операционные системы доступны?",
    answer: "Мы поддерживаем Ubuntu (20.04, 22.04, 24.04), CentOS (7, 8, Stream 9), Debian (10, 11, 12), AlmaLinux (8, 9), Rocky Linux (8, 9) и Windows Server (2016, 2019, 2022). Пользовательские установки ОС также доступны по запросу."
  },
  {
    id: 4,
    question: "Есть ли гарантия возврата денег?",
    answer: "Конечно! Мы предлагаем 3-дневную гарантию возврата денег. Если вы не полностью удовлетворены нашим сервисом, мы вернем ваши деньги без лишних вопросов."
  },
  {
    id: 5,
    question: "Как осуществляется биллинг?",
    answer: "Мы предлагаем гибкие циклы оплаты - ежемесячно, ежеквартально и ежегодно. Все платежи обрабатываются безопасно, и вы можете отменить в любое время без штрафов."
  }
];
// ── Временно скрытые локации ────────────────────────────────────────────────
// Указание директора 03.09.2026: Латвию убрать с главной (блок «Дата-центры»)
// и из меню «Дата-центры» (десктоп и мобильное). Сама страница /vps-latvia,
// маршрут и SEO остаются. Это ВРЕМЕННО — чтобы вернуть, достаточно убрать
// страну из этого списка и пересобрать сайт. Совпадение идёт по полю country
// в обоих языках (`locations` / `locationsRu`).
export const HIDDEN_LOCATIONS = [];

// Список локаций сайта = включённые датацентры в админке биллинга.
// `disabledCodes` приходит из data/liveLocations.js (коды стран, выключенных
// в панели); null означает «панель не ответила» — тогда ничего не прячем.
// HIDDEN_LOCATIONS остаётся ручным рубильником поверх панели.
export const visibleLocations = (language, disabledCodes) => {
  const all = language === 'ru' ? locationsRu : locations;
  const off = Array.isArray(disabledCodes) ? disabledCodes : [];
  return all.filter((loc) => {
    if (HIDDEN_LOCATIONS.includes(loc.country)) return false;
    const m = /\/flags\/([a-z]{2})\.svg/i.exec(loc.flag || '');
    return !(m && off.includes(m[1].toLowerCase()));
  });
};
